export * from './useProductDetailsNavigation.ts';
